import type { TldrawApp } from "pages/flyer/builder/drawer/state";
import * as React from "react";

export const TldrawContext = React.createContext<TldrawApp>({} as TldrawApp);

export const useTldrawApp = () => {
  const context = React.useContext(TldrawContext);
  return context;
};
